import React from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import {Alert} from 'react-bootstrap';
import {
  DiscordIntegrationFeatureDescription,
  IFTTTIntegrationFeatureDescription,
  VoicemodIntegrationFeatureDescription,
} from '../../system/FeatureDescriptionModal';

export const resolveIntegrationLogo = (metaIntegrationId) => {
  switch (metaIntegrationId) {
    case '13597a91-b45e-4105-a8ca-091e9c358dc9':
      return (
        <img
          src={
            'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/discord-integration.png'
          }
          style={{maxHeight: '80%'}}
          alt={'Loading...'}
        />
      );
    case '482583fb-dacb-4df6-9bb6-1855e454620c':
      return (
        <img
          src={
            'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/ifttt.png'
          }
          style={{maxHeight: '80%'}}
          alt={'Loading...'}
        />
      );
    case '50b602a8-bb03-4929-8d2c-75986741fb62':
      return (
        <img
          src={
            'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/ifttt.png'
          }
          style={{maxHeight: '80%'}}
          alt={'Loading...'}
        />
      );
    case MetaVoicemodeIntegrationId:
      return (
        <img
          src={
            'https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/integrations/voicemod-integration.png'
          }
          style={{maxHeight: '80%'}}
          alt={'Loading...'}
        />
      );
    default:
      return <div>Something went wrong</div>;
  }
};

export const resolveFeatureDescription = (metaIntegrationId) => {
  switch (metaIntegrationId) {
    case '13597a91-b45e-4105-a8ca-091e9c358dc9':
      return <DiscordIntegrationFeatureDescription />;
    case '482583fb-dacb-4df6-9bb6-1855e454620c':
      return <IFTTTIntegrationFeatureDescription />;
    case '50b602a8-bb03-4929-8d2c-75986741fb62':
      return <IFTTTIntegrationFeatureDescription />;
    case MetaVoicemodeIntegrationId:
      return <VoicemodIntegrationFeatureDescription />;
    default:
      return <></>;
  }
};

export const MessageAlert = ({message}) => {
  if (message) {
    return (
      <Row>
        <Col md={5}>
          <Alert variant={'warning'}>{message}</Alert>
        </Col>
      </Row>
    );
  } else {
    return <></>;
  }
};

export const MetaVoicemodeIntegrationId =
  'd0a08a5e-29f0-4f52-be45-8209ca36281e';
export const MetaDixperIntegrationId = '6f15deaf-79ea-46a9-b235-925a2e4c1c01';
